/** Pusher wire names for break-notice modal — Echo uses leading dot; raw WS may omit it. */
export const BREAK_ALERT_EVENT_NAMES = ["break:alert", ".break:alert"] as const;

/** Pusher wire names for shift-end modal. */
export const SHIFT_END_ALERT_EVENT_NAMES = ["shift:end-alert", ".shift:end-alert"] as const;

export function subscribeWindowEvents(
  eventNames: readonly string[],
  handler: (event: Event) => void,
): () => void {
  eventNames.forEach((name) => window.addEventListener(name, handler));
  return () => {
    eventNames.forEach((name) => window.removeEventListener(name, handler));
  };
}
